<!-- PIE CHART GENERIC COMPONENT  -->
<template>
    <div class="chart card">
        <div class="card-body">
            <canvas :id="id" :class="classes" aria-label="chart" role="img">
            </canvas>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['id', 'classes', 'config'],
        data() {
            return {
                dates: null
            }
        },
        mounted() {
            console.log('pie chart mounted');
            var id      = this.id
            var classes = this.clasess
            var config  = JSON.parse(this.config)

            new Chart(document.getElementById(id), {
                type: 'doughnut',
                data: config.data, /*{
                    labels: ["Nuevos Contactos", "Todos los Contactos"],
                    datasets: [{
                        label: "Nuevos Contactos",
                        backgroundColor: ["#F39C12","#E5E8E8"],
                        data: [397, 2279]
                    }]
                },*/
                options: config.options, /*{
                    title: {
                        display: true,
                        text: 'Predicted world population (millions) in 2050'
                    },
                    rotation: 1 * Math.PI,
                    circumference: 1 * Math.PI
                }*/
            });

            $(document).on('change', '#start-date', function (event) {
            })
        },
    }
</script>
